const CDN_BASE_URL = 'https://cdn.alignmateapp.com';

export function getAvatarUrl(relativePath?: string): string | undefined {
  if (!relativePath) return undefined;
  if (/^https?:\/\//i.test(relativePath)) return relativePath;
  return `${CDN_BASE_URL}${relativePath.startsWith('/') ? '' : '/'}${relativePath}`;
}
